"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamClient = void 0;
const tslib_1 = require("tslib");
const new_crud_client_1 = require("./new.crud.client");
class TeamClient extends new_crud_client_1.NewCrudClient {
    constructor() {
        super(...arguments);
        this.urlTemplate = '/v1/teams';
    }
    getUsersByTeam(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { teamId } = request, params = tslib_1.__rest(request, ["teamId"]);
            const response = yield this.httpGet(`/v1/teams/${teamId}/users?${this.getQueryString(params)}`);
            return response.payload || [];
        });
    }
    getProjectsByTeam(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { teamId } = request, params = tslib_1.__rest(request, ["teamId"]);
            const response = yield this.httpGet(`/v1/teams/${teamId}/projects?${this.getQueryString(params)}`);
            return response.payload || [];
        });
    }
    removeUser(teamId, userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.httpDelete(`/v1/teams/${teamId}/users/${userId}`);
        });
    }
    removeProject(teamId, projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.httpDelete(`/v1/teams/${teamId}/projects/${projectId}`);
        });
    }
    getTeamsByProjectId(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/teams/projects/${projectId}`);
            return response.payload;
        });
    }
    getTeamProjectsRoles(teamId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/teams/${teamId}/projects/roles`);
            return response.payload;
        });
    }
    setTeamProjectsRoles(teamId, roles) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/teams/${teamId}/projects/roles`, { roles });
            return response.payload;
        });
    }
    removeTeamProjectRoles(teamId, projectIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.httpDelete(`/v1/teams/${teamId}/projects/roles/default`, { projectIds });
        });
    }
}
exports.TeamClient = TeamClient;
//# sourceMappingURL=team.client.js.map